import { sseVisionTransport } from './sseVisionTransport';

// Limite do transporte do Vision: este é o ÚNICO arquivo que sabe qual implementação
// está ativa. Real = pergunta via HTTP→NATS (gate no Rails), resposta streama do
// JetStream pro browser via SSE servido pelo Rails (NATS fica interno). O mock
// (`./mockVisionTransport`) continua disponível pra dev offline — troca-se só o import
// abaixo. Componente e composable não mudam.
const transport = sseVisionTransport;

export const visionClient = {
  // query(payload, onEvent) → Promise<unsubscribe>
  query: (payload, onEvent) => transport.query(payload, onEvent),
};
